import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectCartEvent } from '../selectors';
import { deleteCartTickets } from '../actions';

const EventInfo = () => {
    const event = useSelector(selectCartEvent);
    const dispatch = useDispatch();
    const onDelete = () => {
        dispatch(deleteCartTickets());
    };
    return (
        <span className="your-order-event-details">
            <img className="your-order-event-details__image" src={event.photo} alt={event.title} width="200px"/>
            <span className="your-order-event-details__desc">
                <span className="your-order-event-details__desc__title">{event.title}</span>
                <span className="your-order-event-details__desc__date"><i className="bi bi-calendar" /> {event.startDateTime}</span>
                <span className="your-order-event-details__desc__venue"><i className="bi bi-geo-alt" /> {event.location}</span>
            </span>
            <span className="your-order-event-details__btn btn btn-link" onClick={() => onDelete()}>
                <i className="bi bi-trash"/>
            </span>
        </span>
    );
};
export default EventInfo;
